import { Deserializable, Deserialize } from "../helpers/serialization";

/**
 * Class holding a 32bit representation of an RGBA color. The RGBA components are stored as 0..255 integers
 */
export class Color32 extends Deserializable
{
    @Deserialize()
    public r:number = 0;

    @Deserialize()
    public g:number = 0;

    @Deserialize()
    public b:number = 0;
    
    @Deserialize()
    public a:number = 255;

    static FromString(s:string):Color32
    {
        let match;

        // #rgba format        
        if (match = s.match(/^#([0-9a-f\d]{1})([0-9a-f\d]{1})([0-9a-f\d]{1})([0-9a-f\d]{1})$/i))
        {
            return new Color32(parseInt(match[1], 16)*17, parseInt(match[2], 16)*17, parseInt(match[3], 16)*17, parseInt(match[4], 16)*17);
        }

        // #rgb format        
        if (match = s.match(/^#([0-9a-f\d]{1})([0-9a-f\d]{1})([0-9a-f\d]{1})$/i))
        {
            return new Color32(parseInt(match[1], 16)*17, parseInt(match[2], 16)*17, parseInt(match[3], 16)*17);
        }

        // #rrggbbaa format        
        if (match = s.match(/^#([0-9a-f\d]{2})([0-9a-f\d]{2})([0-9a-f\d]{2})([0-9a-f\d]{2})$/i))
        {
            return new Color32(parseInt(match[1], 16), parseInt(match[2], 16), parseInt(match[3], 16), parseInt(match[4], 16));
        }

        // #rrggbb format        
        if (match = s.match(/^#([0-9a-f\d]{2})([0-9a-f\d]{2})([0-9a-f\d]{2})$/i))
        {
            return new Color32(parseInt(match[1], 16), parseInt(match[2], 16), parseInt(match[3], 16));
        }


        // rgba() format
        if (match = s.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\,\s*(\d+)\s*\)$/i))
        {           
            return new Color32(parseInt(match[1]), parseInt(match[2]), parseInt(match[3]), 255 * parseFloat(match[4]));
        }
        
        // rgb() format
        if (match = s.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i))
        {            
            return new Color32(parseInt(match[1]), parseInt(match[2]), parseInt(match[3]));
        }

        return new Color32();
    }

    static FromObject(input:any):any
    {
        if (typeof input == "string")
        {
            return Color32.FromString(input);
        }
        else
            return super.FromObject(input);
    }

    static Lerp(a:Color32, b:Color32, t:number):Color32
    {
        let c = new Color32((1.0-t)*a.r + t*b.r, (1.0-t)*a.g + t*b.g, (1.0-t)*a.b + t*b.b, (1.0-t)*a.a + t*b.a); 
        return c;
    }

    constructor(r:number = 0, g:number = 0, b:number = 0, a:number = 255)
    {
        super();
        this.r = Math.round(r); this.g = Math.round(g); this.b = Math.round(b); Math.round(a);        
    }

    public ToHex():string
    {
        return `#${(this.r < 16 ? '0' : '') + this.r.toString(16)}${(this.g < 16 ? '0' : '') + this.g.toString(16)}${(this.b < 16 ? '0' : '') + this.b.toString(16)}`;
    }

    public ToRGBA():string
    {
        return `rgba(${this.r.toString()}, ${this.g.toString()}, ${this.b.toString()}, ${(this.a / 255).toString()})`;
    }
}